import {Action} from "@ngrx/store";

export const LOAD_BACKUP_LIMITS: string = '[backup limits] Load User';
export const LOAD_BACKUP_LIMITS_SUCCESS: string = '[backup limits] Load User Success';
export const LOAD_BACKUP_LIMITS_FAIL: string = '[backup limits] Load User Fail';

export class LoadBackupLimits implements Action {

  readonly type: string = LOAD_BACKUP_LIMITS;

}

export class LoadBackupLimitsSuccess implements Action {

  readonly type: string = LOAD_BACKUP_LIMITS_SUCCESS;
  constructor(public payload: any) {}

}

export class LoadBackupLimitsFail implements Action {

  readonly type: string = LOAD_BACKUP_LIMITS_FAIL;
  constructor(public payload: string) {}

}

export type BackupLimitsAction = LoadBackupLimits | LoadBackupLimitsSuccess | LoadBackupLimitsFail;
